import { ComponentProps, ComponentType, memo } from 'react';

type PropsComparator<C extends ComponentType> = (
  prevProps: Readonly<ComponentProps<C>>,
  nextProps: Readonly<ComponentProps<C>>
) => boolean;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function typedMemo<C extends ComponentType<any>>(
  Component: C,
  propsComparator?: PropsComparator<C>
) {
  return memo(Component, propsComparator) as unknown as C;
}
